export default [
    'transport',
    'brand',
    'label_product_catalog',
];
